import { render, staticRenderFns } from "./AddTenantDialog.vue?vue&type=template&id=74a743c4"
import script from "./AddTenantDialog.vue?vue&type=script&lang=ts"
export * from "./AddTenantDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports